const i18nEl = document.querySelector('.fiche-i18n');
let i18n = {
  titre_performance: 'Performance',
  titre_activites: 'Activités'
};

if (i18nEl) {
  try {
    i18n = JSON.parse(i18nEl.textContent.trim());
  } catch (e) {
    console.warn('Erreur parsing des traductions fiche-performance');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.fiche-performance');
  if (!container) {
    console.warn('Aucun conteneur .fiche-performance trouvé');
    return;
  }

  const el = document.querySelector('.fiche-data');
  if (!el) {
    console.warn('Bloc .fiche-data introuvable');
    return;
  }
  
  const data = el.textContent.trim();
  if (!data) {
    console.warn('Le script JSON fiche-data est vide');
    return;
  }

  let caracteristiques = [];
  let activites = [];

  try {
    const parsed = JSON.parse(data);
    caracteristiques = (parsed.caracteristiques || []).sort((a, b) => b.valeur - a.valeur);
    activites = (parsed.activites || []).sort((a, b) => b.valeur - a.valeur);

  } catch (e) {
    console.error('Erreur parsing JSON fiche-performance :', e);
    return;
  }

  const makeBar = ({ label, valeur }) => {
    return `
      <div class="fiche-bar">
        <div class="fiche-bar-track">
          <div class="fiche-bar-fill" style="width:${(valeur / 10) * 100}%"> </div>
        </div>
        <div class="fiche-bar-bottom">
          <div class="fiche-bar-label">${label} <span class="fiche-icon"></span></div>
          <div class="fiche-bar-value">${valeur} / 10</div>
        </div>
      </div>`;
  };


  const makeCircle = ({ label, valeur }) => {
    var percent = (valeur / 10) * 100;
    if (percent>=92) percent = 94;
    const dash = `${percent}, 100`;
    
    return `
      <div class="fiche-circle">
        <div class="fiche-circle-graph">
          <svg viewBox="0 0 36 36" style="transform: rotate(+90deg);">
            <path class="bg" d="M18 2a16 16 0 1 1 0 32a16 16 0 1 1 0 -32"/>
            <path class="fg" d="M18 2a16 16 0 1 1 0 32a16 16 0 1 1 0 -32"
                  stroke-dasharray="${dash}"/>
          </svg>
          <div class="fiche-circle-center">${valeur} / 10</div>
        </div>
        <div class="fiche-circle-label">${label}</div>
      </div>`;
  };

  const html = `
    <div class="fiche-block">
      <h3 class="fiche-title">${i18n.titre_performance} <span class="fiche-icon"></span></h3>
      <div class="fiche-bars">${caracteristiques.map(makeBar).join('')}</div>
      <h3 class="fiche-title">${i18n.titre_activites} <span class="fiche-icon"></span></h3>
      <div class="fiche-circles">${activites.map(makeCircle).join('')}</div>
    </div>
  `;

  container.innerHTML = html;
});
